import { State } from '../../reducers/rootReducer'
import UserGarageInfo from '../../../entities/UserGarageInfo'

const userGarageInfoSelector = (state: State): UserGarageInfo => state.userGarageInfo

export default userGarageInfoSelector
